export default __webpack_public_path__ + "static/hackages_logo@2x-2f0ed58e2cf74b3b1e08e6f0995d2922.png";